import React from "react";
import { Link } from "react-router-dom";

import bClass from "../Results/Result.module.css";
import classes from "./Home.module.css";

import {
  formatPublishedDate,
  formatDuration,
  formatViews
} from "../../utility";

export default function Widget(props) {
  return (
    <Link
      to={{
        pathname: "/watch",
        videoId: props.videoId,
        channelId: props.channelId,
        fromHome: true
      }}
    >
      <div className={classes.Widget}>
        <div className={classes.Thumbnail}>
          <span className={[bClass.WatchLater, classes.Clock].join(" ")}>
            <i className="fas fa-clock" />
          </span>
          <img src={props.snip.thumbnails.medium.url} alt="thumbnail" />
          <span className={bClass.Duration}>
            {formatDuration(props.duration)}
          </span>
        </div>
        <div className={classes.Details}>
          <h5>{props.snip.title}</h5>
          <div>{props.snip.channelTitle}</div>
          <div>
            <span style={{ textTransform: "uppercase" }}>
              {formatViews(props.views)}
            </span>{" "}
            views <span className={classes.Dot} />{" "}
            {formatPublishedDate(props.snip.publishedAt)}
          </div>
        </div>
      </div>
    </Link>
  );
}
